import React from "react"

function IconStatusDnd({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (<svg  fill={color} fuze-icon="status-dnd"viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{height: height || fontSize}} originalclass="fz-icon fz-icon-status-dnd"{...props}><g fillRule="nonzero" fill={color}><path d="M21.818 12A9.817 9.817 0 0 0 12 2.182 9.816 9.816 0 0 0 2.182 12 9.817 9.817 0 0 0 12 21.818c5.422 0 9.818-4.396 9.818-9.818z" fill={color2 || color}/><path d="M9.818 8.916a6.545 6.545 0 0 0 7.4 6.49 6 6 0 0 1-10.673-3.763A6.001 6.001 0 0 1 10.502 6a6.51 6.51 0 0 0-.684 2.916z" fill={color}/></g></svg>)
}

export default IconStatusDnd
